import gql from 'graphql-tag';

// global subscription when a new message occurs.
export const ON_NEW_MESSAGE = gql`
  subscription onNewMessage {
    onNewMessage {
      uuid
      senderUuid
      receiverUuid
      content
      sentAt
      readAt
      conversationUuid
      messageResources {
        uuid
        order
        meditationId
        programId
        companyAdditionalBenefitId
      }
    }
  }
`;

// global subscription when a message updates.
export const ON_MESSAGE_UPDATE = gql`
  subscription onMessageUpdate {
    onMessageUpdate {
      uuid
      senderUuid
      receiverUuid
      content
      sentAt
      readAt
      conversationUuid
      messageResources {
        uuid
        order
        meditationId
        programId
        companyAdditionalBenefitId
      }
    }
  }
`;

// global subscription when a message updates.
export const ON_NEW_CONVERSATION = gql`
  subscription onNewConversation {
    onNewConversation {
      active
      uuid
      createdAt
      member {
        uuid
        email
        firstName
        lastName
        role
        avatar
      }
      newestMessage {
        uuid
        senderUuid
        receiverUuid
        content
        sentAt
        readAt
        conversationUuid
      }
    }
  }
`;
